module.exports = __webpack_public_path__ + "img/trust-process2.61d4f56f.png";